// extracted by mini-css-extract-plugin
export var active = "carousel-module--active--29f48";
export var carousel = "carousel-module--carousel--fe4b1";
export var carousel__content = "carousel-module--carousel__content--9da0d";
export var carousel__navigation = "carousel-module--carousel__navigation--4af19";
export var nav_next = "carousel-module--nav_next--ba5af";
export var nav_prev = "carousel-module--nav_prev--8b5c4";